export enum ZIndexStackingContext {
  // baseline z-index, for items that need to be placed on top of general layouts without a z-index (e.g. a menu over a list item)
  low = 1,
  // medium z-index, for items that need to be laid on top of others that already have an applied z-index (e.g. filter pill menus)
  medium = 50,
  // highest z-index, for items that must be always placed on top of others (e.g. side drawers) or on top of the sidebar (e.g. tooltips)
  high = 100,
}
